var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover.right",value:({
    title: _vm.tooltip,
    disabled: !_vm.value,
  }),expression:"{\n    title: tooltip,\n    disabled: !value,\n  }",modifiers:{"hover":true,"right":true}}],class:`mc-status mc-status--${_vm.value ? 'green' : 'red'}`},[_vm._v(" "+_vm._s(_vm.label)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }